import { Injectable } from '@angular/core';
import { getAuth } from 'firebase/auth';
import { AuthBridge } from '@crewdle/auth-bridge';

import { getFirebaseApp } from '../firebase';
import { environment } from '../../../environments/environment';

/**
 * Holds the shared-session bridge to the centralized auth service
 * (auth.crewdle.ai). Used by the auth guard to silently bootstrap a local
 * Firebase session from the `.crewdle.ai` cookie, or redirect to login.
 */
@Injectable({ providedIn: 'root' })
export class AuthBridgeService {
  readonly bridge = new AuthBridge({
    auth: getAuth(getFirebaseApp()),
    authBaseUrl: environment.authBaseUrl,
  });
}
